
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RateInvalidityNotificationComponent } from './rate-invalidity-notification.component';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { QuotationQuotationsResourceModule } from 'libraries/service/resources/quotation-quotations/quotation-quotations-resource.module';

@NgModule({
    imports: [
        CommonModule,
        NotificationModule,
        BtnModule,
        QuotationQuotationsResourceModule,
    ],
    declarations: [
        RateInvalidityNotificationComponent,
    ],
    exports: [
        RateInvalidityNotificationComponent,
    ],
})
export class RateInvalidityNotificationModule {}